export const API_V1_URI = "/api/v1";
export const ACCOUNT_API_LOGIN = API_V1_URI + "/accounts/login";
export const ACCOUNT_API_PROFILE = API_V1_URI + "/accounts/profile";
export const ACCOUNT_API_PASSWORD = API_V1_URI + "/accounts/update-password";
export const ACCOUNT_API_UPDATE = API_V1_URI + "/accounts/update-profile";
export const ACCOUNT_API_FORGOT_PASSWORD =
  API_V1_URI + "/accounts/forgot-password";
export const ACCOUNT_API_RESET_PASSWORD =
  API_V1_URI + "/accounts/reset-password";
export const ACCOUNT_API_VERIFY_PHONE = API_V1_URI + "/accounts/verify-phone";
export const ACCOUNT_API_REFRESH_TOKEN = API_V1_URI + "/accounts/refresh-token";
export const ACCOUNT_API_SIGN_UP_PHONE =
  API_V1_URI + "/website/accounts/sign-up-phone";
export const ACCOUNT_API_SIGN_IN_PHONE =
  API_V1_URI + "/website/accounts/sign-in-phone";
export const CLIENT_CUSTOMER_API = API_V1_URI + "/client/customers";
export const ACCOUNT_API_LOGOUT = API_V1_URI + "/website/accounts/logout";
export const CUSTOMER_ADDRESS_API = API_V1_URI + "/client/customer_addresses";
export const ADDRESS_API = API_V1_URI + "/addresses";
export const PROVINCE_API = ADDRESS_API + "/provinces";
export const DISTRICT_API = ADDRESS_API + "/districts";
export const WARD_API = ADDRESS_API + "/wards";
export const CUSTOMER_ORDER_API = API_V1_URI + "/client/customer_orders";
export const CUSTOMER_ORDER_API_SEARCH = CUSTOMER_ORDER_API + "/search";
export const SHOPPING_CART_ADD_ITEMS_API =
  API_V1_URI + "/client/shopping-cart/create-items";
export const SHOPPING_WEBSITE_CART_API = API_V1_URI + "/website/shopping-cart";
export const SHOPPING_WEBSITE_MERGED_CART_API = SHOPPING_WEBSITE_CART_API + "/merged-cart";